/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsMarketBarcodeVo } from './GoodsMarketBarcodeVo';
import {
    GoodsMarketBarcodeVoFromJSON,
    GoodsMarketBarcodeVoFromJSONTyped,
    GoodsMarketBarcodeVoToJSON,
    GoodsMarketBarcodeVoToJSONTyped,
} from './GoodsMarketBarcodeVo';

/**
 * 
 * @export
 * @interface GoodsVo
 */
export interface GoodsVo {
    /**
     * 商品id
     * @type {number}
     * @memberof GoodsVo
     */
    id?: number;
    /**
     * 商品skuid
     * @type {number}
     * @memberof GoodsVo
     */
    skuId?: number;
    /**
     * 订单下显示商品的排序
     * @type {number}
     * @memberof GoodsVo
     */
    sort?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof GoodsVo
     */
    name?: string;
    /**
     * 商品名称（英文）
     * @type {string}
     * @memberof GoodsVo
     */
    nameEn?: string;
    /**
     * 商品可用数量
     * @type {number}
     * @memberof GoodsVo
     */
    availableQuantity?: number;
    /**
     * 商品单价
     * @type {number}
     * @memberof GoodsVo
     */
    unitPrice?: number;
    /**
     * 商品总价 (韩元)
     * @type {number}
     * @memberof GoodsVo
     */
    totalPriceKrw?: number;
    /**
     * 商品总价(美元)
     * @type {number}
     * @memberof GoodsVo
     */
    totalPriceUsd?: number;
    /**
     * 商品链接  没有就用空字符串
     * @type {string}
     * @memberof GoodsVo
     */
    url?: string;
    /**
     * 商品图片链接
     * @type {string}
     * @memberof GoodsVo
     */
    imgUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof GoodsVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof GoodsVo
     */
    size?: string;
    /**
     * 原产地
     * @type {string}
     * @memberof GoodsVo
     */
    origin?: string;
    /**
     * 品牌
     * @type {string}
     * @memberof GoodsVo
     */
    brand?: string;
    /**
     * 市场条码
     * @type {string}
     * @memberof GoodsVo
     */
    marketBarcode?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof GoodsVo
     */
    marketProNm?: string;
    /**
     * 市场选项名称
     * @type {string}
     * @memberof GoodsVo
     */
    marketOptionName?: string;
    /**
     * 市场选项ID
     * @type {string}
     * @memberof GoodsVo
     */
    marketOptionId?: string;
    /**
     * 当前订单商品的平台条码快照列表
     * @type {Array<GoodsMarketBarcodeVo>}
     * @memberof GoodsVo
     */
    marketBarcodes?: Array<GoodsMarketBarcodeVo>;
    /**
     * 市场到期日期
     * @type {string}
     * @memberof GoodsVo
     */
    marketExpiryDate?: string;
    /**
     * 是否打印原产地 0 不打印，1 打印
     * @type {number}
     * @memberof GoodsVo
     */
    originPrint?: number;
    /**
     * CO商品名称（英文）
     * @type {string}
     * @memberof GoodsVo
     */
    coGoodsNameEn?: string;
    /**
     * CO海关编码
     * @type {string}
     * @memberof GoodsVo
     */
    coHsCode?: string;
    /**
     * 商品状态
     * @type {number}
     * @memberof GoodsVo
     */
    status?: number;
    /**
     * 入库时间
     * @type {string}
     * @memberof GoodsVo
     */
    warehousingTime?: string;
    /**
     * 备注
     * @type {string}
     * @memberof GoodsVo
     */
    remark?: string;
    /**
     * 是否为合包商品
     * @type {number}
     * @memberof GoodsVo
     */
    combined?: number;
    /**
     * 商品来源  1 普通url下单， 2 sku下单， 3 库存下单， 4 复制购物车
     * @type {number}
     * @memberof GoodsVo
     */
    sourceType?: number;
    /**
     * 重量 kg
     * @type {number}
     * @memberof GoodsVo
     */
    weight?: number;
    /**
     * 体积  立方米
     * @type {number}
     * @memberof GoodsVo
     */
    cbm?: number;
    /**
     * 长 厘米
     * @type {number}
     * @memberof GoodsVo
     */
    length?: number;
    /**
     * 宽 厘米
     * @type {number}
     * @memberof GoodsVo
     */
    width?: number;
    /**
     * 高 厘米
     * @type {number}
     * @memberof GoodsVo
     */
    height?: number;
    /**
     * 商品初始数量  分单的时候，要是分商品，那商品可用数量和初始数量都要减
     * @type {number}
     * @memberof GoodsVo
     */
    initQuantity?: number;
    /**
     * 只在基础商品上上传发票url
     * @type {string}
     * @memberof GoodsVo
     */
    invoiceUrl?: string;
    /**
     * 发票状态 0 未开票，1 已开票， 2 已上传
     * @type {number}
     * @memberof GoodsVo
     */
    invoiceStatus?: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof GoodsVo
     */
    skuProductId?: number;
    /**
     * 订单id
     * @type {number}
     * @memberof GoodsVo
     */
    orderId?: number;
    /**
     * 用户id
     * @type {number}
     * @memberof GoodsVo
     */
    userId?: number;
    /**
     * 商品是否为从火箭订单分出的快递件商品 0 不是， 1 是
     * @type {number}
     * @memberof GoodsVo
     */
    simple?: number;
    /**
     * 商品跟踪id，分单合单的时候，如果商品有分裂，需要传递这个trace_id
     * @type {number}
     * @memberof GoodsVo
     */
    traceId?: number;
    /**
     * 购买商品的所在平台的订单号
     * @type {string}
     * @memberof GoodsVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 主运单号
     * @type {string}
     * @memberof GoodsVo
     */
    mainTrackingNumber?: string;
    /**
     * 问题商品原因 1 到货数量有误， 2 商品破损， 3 商品有误， 4 剩余商品（因为一个sku中的一个商品有问题，导致配套的好的商品也会到有误订单中）
     * @type {number}
     * @memberof GoodsVo
     */
    wrongGoodsReason?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof GoodsVo
     */
    code?: string;
    /**
     * 商品货币编码
     * @type {string}
     * @memberof GoodsVo
     */
    currencyCode?: string;
    /**
     * 中国国内
     * @type {number}
     * @memberof GoodsVo
     */
    chinaDomesticShippingFee?: number;
    /**
     * 采购附加费
     * @type {number}
     * @memberof GoodsVo
     */
    additionalFee?: number;
    /**
     * 负责采购公司要收的采购税点，实际上就是采购劳务费
     * @type {number}
     * @memberof GoodsVo
     */
    purchaseTax?: number;
    /**
     * 开发票公司名称
     * @type {string}
     * @memberof GoodsVo
     */
    invoiceCompany?: string;
    /**
     * 是否从库存来的商品 0 不是  1 是
     * @type {number}
     * @memberof GoodsVo
     */
    fromStock?: number;
    /**
     * 购买商品的所在平台的url
     * @type {string}
     * @memberof GoodsVo
     */
    purchasePlatformUrl?: string;
    /**
     * 原产地标作业方式
     * @type {string}
     * @memberof GoodsVo
     */
    originJob?: string;
    /**
     * 商品是否可以原包装出库  0 不可以，1 可以
     * @type {number}
     * @memberof GoodsVo
     */
    originPackageOutbound?: number;
    /**
     * 合包商品id
     * @type {number}
     * @memberof GoodsVo
     */
    parentGoodsId?: number;
    /**
     * 商品总价(人民币)
     * @type {number}
     * @memberof GoodsVo
     */
    totalPriceCny?: number;
}

/**
 * Check if a given object implements the GoodsVo interface.
 */
export function instanceOfGoodsVo(value: object): value is GoodsVo {
    return true;
}

export function GoodsVoFromJSON(json: any): GoodsVo {
    return GoodsVoFromJSONTyped(json, false);
}

export function GoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPriceKrw': json['totalPriceKrw'] == null ? undefined : json['totalPriceKrw'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'url': json['url'] == null ? undefined : json['url'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcodes': json['marketBarcodes'] == null ? undefined : ((json['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoFromJSON)),
        'marketExpiryDate': json['marketExpiryDate'] == null ? undefined : json['marketExpiryDate'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'coGoodsNameEn': json['coGoodsNameEn'] == null ? undefined : json['coGoodsNameEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'status': json['status'] == null ? undefined : json['status'],
        'warehousingTime': json['warehousingTime'] == null ? undefined : json['warehousingTime'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'invoiceUrl': json['invoiceUrl'] == null ? undefined : json['invoiceUrl'],
        'invoiceStatus': json['invoiceStatus'] == null ? undefined : json['invoiceStatus'],
        'skuProductId': json['skuProductId'] == null ? undefined : json['skuProductId'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'mainTrackingNumber': json['mainTrackingNumber'] == null ? undefined : json['mainTrackingNumber'],
        'wrongGoodsReason': json['wrongGoodsReason'] == null ? undefined : json['wrongGoodsReason'],
        'code': json['code'] == null ? undefined : json['code'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'chinaDomesticShippingFee': json['chinaDomesticShippingFee'] == null ? undefined : json['chinaDomesticShippingFee'],
        'additionalFee': json['additionalFee'] == null ? undefined : json['additionalFee'],
        'purchaseTax': json['purchaseTax'] == null ? undefined : json['purchaseTax'],
        'invoiceCompany': json['invoiceCompany'] == null ? undefined : json['invoiceCompany'],
        'fromStock': json['fromStock'] == null ? undefined : json['fromStock'],
        'purchasePlatformUrl': json['purchasePlatformUrl'] == null ? undefined : json['purchasePlatformUrl'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
        'parentGoodsId': json['parentGoodsId'] == null ? undefined : json['parentGoodsId'],
        'totalPriceCny': json['totalPriceCny'] == null ? undefined : json['totalPriceCny'],
    };
}

export function GoodsVoToJSON(json: any): GoodsVo {
    return GoodsVoToJSONTyped(json, false);
}

export function GoodsVoToJSONTyped(value?: GoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'skuId': value['skuId'],
        'sort': value['sort'],
        'name': value['name'],
        'nameEn': value['nameEn'],
        'availableQuantity': value['availableQuantity'],
        'unitPrice': value['unitPrice'],
        'totalPriceKrw': value['totalPriceKrw'],
        'totalPriceUsd': value['totalPriceUsd'],
        'url': value['url'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'origin': value['origin'],
        'brand': value['brand'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcodes': value['marketBarcodes'] == null ? undefined : ((value['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoToJSON)),
        'marketExpiryDate': value['marketExpiryDate'],
        'originPrint': value['originPrint'],
        'coGoodsNameEn': value['coGoodsNameEn'],
        'coHsCode': value['coHsCode'],
        'status': value['status'],
        'warehousingTime': value['warehousingTime'],
        'remark': value['remark'],
        'combined': value['combined'],
        'sourceType': value['sourceType'],
        'weight': value['weight'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'initQuantity': value['initQuantity'],
        'invoiceUrl': value['invoiceUrl'],
        'invoiceStatus': value['invoiceStatus'],
        'skuProductId': value['skuProductId'],
        'orderId': value['orderId'],
        'userId': value['userId'],
        'simple': value['simple'],
        'traceId': value['traceId'],
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'mainTrackingNumber': value['mainTrackingNumber'],
        'wrongGoodsReason': value['wrongGoodsReason'],
        'code': value['code'],
        'currencyCode': value['currencyCode'],
        'chinaDomesticShippingFee': value['chinaDomesticShippingFee'],
        'additionalFee': value['additionalFee'],
        'purchaseTax': value['purchaseTax'],
        'invoiceCompany': value['invoiceCompany'],
        'fromStock': value['fromStock'],
        'purchasePlatformUrl': value['purchasePlatformUrl'],
        'originJob': value['originJob'],
        'originPackageOutbound': value['originPackageOutbound'],
        'parentGoodsId': value['parentGoodsId'],
        'totalPriceCny': value['totalPriceCny'],
    };
}

